// Hooks
import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';

// Lib
import {
    ALBUM_TYPE_STEP,
    ALBUM_MANUAL_STEP,
    ALBUM_AUTOMATIC_STEP
} from '@/lib/albums/albumFunnel/steps';

// Components
import { SelectTypeStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/SelectTypeStep';
import { ManualStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep';
import { AutomaticStep } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/AutomaticStep';

export const ModalSteps = (props) => {
    const { albumInfo } = useAlbumContext();
    switch (albumInfo?.currentStep) {
        case ALBUM_MANUAL_STEP:
            return <ManualStep {...props} />;
        case ALBUM_AUTOMATIC_STEP:
            return <AutomaticStep {...props} />;
        case ALBUM_TYPE_STEP:
        default:
            return <SelectTypeStep {...props} />;
    }
};
